"use client";

// IMPORTANT: jotai-devtools must be imported before createStore() for atoms to show up
// This is a known issue: https://github.com/jotaijs/jotai-devtools/discussions/197
// We need to import the actual DevTools module to ensure proper initialization
import { DevTools } from "jotai-devtools";

import { createStore, Provider } from "jotai";
import { IdentityProvider, SessionProvider } from "@zapier/identity";
import dynamic from "next/dynamic";
import type { ComponentType } from "react";

let JotaiDevTools: ComponentType<{ children: React.ReactNode }> | null = null;

if (process.env.NODE_ENV !== "production") {
  JotaiDevTools = dynamic(
    () =>
      import("@zapier/canvas/src/components/CanvasLayout/JotaiDevTools").then(
        (mod) => mod.JotaiDevTools,
      ),
    { ssr: false },
  );
}

export const store = createStore();

export function CanvasProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      {JotaiDevTools && (
        <JotaiDevTools>
          <DevTools store={store} theme="dark" />
        </JotaiDevTools>
      )}
      <IdentityProvider>
        <SessionProvider>{children}</SessionProvider>
      </IdentityProvider>
    </Provider>
  );
}
